export default __webpack_public_path__ + "static/media/ico_user_guide4.b04aa07c.png";